import React from "react";
import { Checklist } from "@trussle/external-components";
import "./checklistCard.scss";
import { GlassmorphicCard } from "../GlassmorphicCard";

interface IChecklistCardProps {
  title: string;
  items: string[];
}

export const ChecklistCard: React.FC<IChecklistCardProps> = ({
  title,
  items
}) => (
  <GlassmorphicCard>
    <p className="checklist-card--title">
      {title}
    </p>
    <Checklist
      items={items}
      type="secondary"
      classOverrides={{ list: "checklist-card--list-ovr" }}
    />
  </GlassmorphicCard>
);
